<template lang="pug">

    div(v-on:submit='persist()').field
        dropdown-field(
            v-bind:label='label '
            v-bind:optionLabel='optionLabel'
            v-bind:optionValue='optionValue'
            v-bind:options='options'
            v-model='mutable'
        )

        modal(ref="modal" :allow-multiple="true")
            span(slot="header") Kampagne erstellen

            form.ui.form(slot="content")
                create-form(
                    ref="form"
                    :segment='false'
                    :company-models='[ companyModel ]'
                    v-model='mutableCampaign'
                )

            action-row(slot='footer' v-on:cancel="cancel()" v-on:save="submit()" save-type='button')

</template>

<script>
    import * as R from 'ramda'
    import CreateForm from './CreateForm'
    import ActionRow from '@/components/form/ActionRow'
    import DropdownField from '@/components/form/DropdownField'
    import Modal from '@/components/app/Modal'

    //noinspection ReservedWordAsName
    export default {
        name: 'campaign-dropdown-field-component',

        components: { ActionRow, CreateForm, DropdownField, Modal },

        computed: {

            mutable: {
                get() { return this.value },
                set(value) {
                    // Pruefen ob neue Kampagne erstellt werden soll
                    if (value === 0) {
                        return this.showModal()
                    }

                    this.$emit('input', value)
                }
            },

            options() {
                return [ { id: 0, name: '- Neue Kampagne erstellen -' }, ...this.campaignModels ]
            },

            purchasers() {
                return [ this.companyModel ]
            }

        },

        data() {
            return {
                mutableCampaign: { }
            }
        },

        methods: {

            cancel() {
                this.$emit('input', undefined)
                this.$refs.modal.close()
            },

            persist() {
                const onPersistSuccess = campaignModel => {
                    // Growl anzeigen
                    this.$growl.success('Kampagne wurde erstellt')

                    // Kampagnen-ID "setzen"
                    this.$emit('input', campaignModel.id)

                    // Modal closen
                    this.$refs.modal.close()

                    return Promise.resolve()
                }

                const onPersistFailure = e => {
                    this.$growl.fatal('Kampagne konnte nicht gespeichert werden. Bitte Support kontaktieren', e)
                }

                const onValidationSuccess = () => {
                    // Kampagne speichern
                    return this.$refs.form.create()
                        .then(onPersistSuccess)
                        .catch(onPersistFailure)
                }
                const onValidationFailure = R.always(undefined)

                // Validierung
                this.$refs.form.validate()
                    .then(R.ifElse(R.equals(true), onValidationSuccess, onValidationFailure))

            },

            showModal() {
                // Model vorbereiten
                this.mutableCampaign = {
                    company: this.companyModel.id
                }

                // Benutzer und Personen des Unternehmens laden
                Promise.all([
                    this.$store.dispatch('users/loadAllByCompanyId', { companyId: this.companyModel.id }),
                    this.$store.dispatch('persons/loadAllByCompanyId', { companyId: this.companyModel.id })
                ])

                    // Modal anzeigen
                    .then(this.$refs.modal.show)
                    .catch(e => this.$growl.fatal('Benutzer konnten nicht geladen werden', e))
            },

            submit() {
                this.persist()
            }

        },

        props: {

            companyModel: {
                type: Object,
                required: true
            },

            campaignModels: {
                type: Array,
                required: true
            },

            label: {
                type: String,
                default: 'Kampagne'
            },

            optionLabel: {
                type: String,
                default: 'name'
            },

            optionValue: {
                type: String,
                default: 'id'
            },

            value: {
                type: Number
            }

        }

    }


</script>
